'use strict';

/** Refersion / Outsite affiliate — Coolliving */
const OUTSITE_AFFILIATE_RFSN = '9325812.0d24ed';
const OUTSITE_AFFILIATE_FALLBACK = `https://www.outsite.co/?rfsn=${OUTSITE_AFFILIATE_RFSN}`;

const OUTSITE_AFFILIATE_SOURCES = new Set(['outsite', 'outsitenyc']);

function isOutsiteAffiliateSource(source) {
  return OUTSITE_AFFILIATE_SOURCES.has(String(source || '').toLowerCase());
}

/**
 * URL de afiliado para clicks (ContractCard, mapa, widget…).
 * Siempre el link genérico con rfsn — no deep links a fichas concretas.
 */
function buildOutsiteAffiliateUrl(_listingUrl) {
  return OUTSITE_AFFILIATE_FALLBACK;
}

module.exports = {
  OUTSITE_AFFILIATE_RFSN,
  OUTSITE_AFFILIATE_FALLBACK,
  isOutsiteAffiliateSource,
  buildOutsiteAffiliateUrl,
};
